export default __webpack_public_path__ + "static/media/placeholder-audio.6be98d7a.png";